import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {
  BodyMedium,
  SubTitleMedium,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {Modal} from '@spaced-out/ui-design-system/lib/components/Modal';
import {SemanticIcon} from '@spaced-out/ui-design-system/lib/components/Icon';

import css from './request-more-availability-form.css';


type ConfirmProceedModalProps = {
  isOpen: boolean;
  hasError: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const ConfirmProceedModal = ({
  isOpen,
  hasError,
  isSubmitting,
  onClose,
  onConfirm,
}: ConfirmProceedModalProps) => {
  const {t} = useLabelTranslation();

  return (
    <Modal
      size="small"
      tapOutsideToClose
      isOpen={isOpen}
      onClose={onClose}
      classNames={{content: css.confirmModal}}
    >
      <div className={css.confirmModalIcon}>
        <SemanticIcon
          type="solid"
          size="small"
          name="warning"
          semantic="warning"
        />
      </div>
      <div className={css.confirmModalContent}>
        <SubTitleMedium className={css.confirmModalTitle}>
          {t('Confirm_Proceed', 'Confirm Proceed?')}
        </SubTitleMedium>
        <BodyMedium color="secondary" className={css.confirmModalDescription}>
          {t(
            'Are_you_sure_you_want_to_proceed',
            'Are you sure you want to proceed?',
          )}
        </BodyMedium>
      </div>
      <div className={css.confirmModalActions}>
        <Button
          size="medium"
          type="tertiary"
          disabled={isSubmitting}
          onClick={onClose}
        >
          {t('Close', 'Close')}
        </Button>
        <Button
          size="medium"
          type="primary"
          isLoading={isSubmitting}
          onClick={onConfirm}
          disabled={hasError}
        >
          {t('Confirm', 'Confirm')}
        </Button>
      </div>
    </Modal>
  );
};
